// 支払いの有効期限（分）
const PAYMENT_DEADLINE = 10;

// 支払い正常完了ステータス
export const successStatus = [5];

// 支払いキャンセルステータス
export const cancelStatus = [
  {
    // 決済キャンセル（タイムアウト）
    statusCode: 6,
    message: `${PAYMENT_DEADLINE}分間、決済が待機状態だった為、決済処理をキャンセルしました。再度精算画面にてご精算をお願いいたします。`,
  },
];

// 支払いキャンセルステータスのしきい値
// NOTE: 100番以上のステータスは、支払いエラーとして扱う
export const errorStatus = {
  borderStatus: 100,
  message: '精算時にエラーが発生しました。もう一度やり直してください。',
};

// 定期利用券の更新を促す残り日数のしきい値
export const ALMOST_EXPIRED_LIMIT = 10;

// 定期利用券購入方法のSTEP
export const passPaymentSteps = [
  {
    id: 1,
    title: '定期利用券を購入したい駐車場を検索し、駐車場情報を表示',
    supplementary: '定期利用券対象の駐車場・駐輪場でのみご利用いただけます。',
  },
  {
    id: 2,
    title:
      '「定期利用券を購入して精算する」もしくは「定期利用券を購入」をタップ',
  },
  {
    id: 3,
    title: '利用期間、お支払い方法を選択して定期利用券を購入',
  },
];
